import {Observable, Subject} from 'rxjs';
import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Cacheable, CacheBuster} from 'ts-cacheable';
import {DataResponse, ListResponse, SuccessResponse} from '../models/response.model';
import {SchoolingParticipant, SchoolingParticipantDetails} from '../models/schooling-participant.model';

const cacheNotifier: Subject<void> = new Subject();

@Injectable({
  providedIn: 'root'
})
export class SchoolingParticipantService {

  constructor(private api: ApiService) {
  }

  @Cacheable({
    cacheBusterObserver: cacheNotifier
  })
  getList(params?: object): Observable<ListResponse<SchoolingParticipant>> {
    return this.api.get(`/schooling/participants`, params);
  }

  getListDetails(params?: object): Observable<ListResponse<SchoolingParticipantDetails>> {
    return this.api.get(`/schooling/participant-list`, params);
  }

  getById(id: number): Observable<DataResponse<SchoolingParticipant>> {
    return this.api.get(`/schooling/participant/${id}`);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  create(data: object): Observable<DataResponse<SchoolingParticipant>> {
    return this.api.post(`/schooling/participant`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  createMultiple(data: object): Observable<DataResponse<SuccessResponse>> {
    return this.api.post(`/schooling/participants`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  update(id: number, data: object): Observable<DataResponse<SchoolingParticipant>> {
    return this.api.put(`/schooling/participant/${id}`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  delete(id: number): Observable<SuccessResponse> {
    return this.api.delete(`/schooling/participant/${id}`);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  deleteMultiple(data: object): Observable<SuccessResponse> {
    return this.api.delete(`/schooling/participant/deleteMultiple`, data);
  }


  static clearCache() {
    cacheNotifier.next();
  }
}
